import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  open(event) {
    if (event.target.closest("a, button, input, select, textarea, label")) return
    Turbo.visit(this.urlValue)
  }

  keydown(event) {
    if (!['Enter', ' '].includes(event.key)) return
    if (event.target !== this.element) return

    event.preventDefault()
    Turbo.visit(this.urlValue)
  }
}
